import produce from 'immer'
import { cloneDeep } from 'lodash'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { State, Action } from './types'
import { initEvent, initMeta } from 'Store/common/common.reducer'
import parseErrorMessage from 'helpers/parseErrorMessage'
import { convertMetaData } from 'Store/common/common.function'

const initialState: State = {
  list: {
    data: [],
    meta: cloneDeep(initMeta),
  },
  listEvent: cloneDeep(initEvent),
  actionEvent: cloneDeep(initEvent),
  detail: undefined,
  detailEvent: cloneDeep(initEvent),
  merchantTax: {
    updateEvent: cloneDeep(initEvent),
    event: cloneDeep(initEvent),
    data: undefined,
  },
  allCustomerTax: [],
}

export default function(state: State = initialState, action: Action) {
  return produce(state, draft => {
    let response
    switch (action.type) {
      case getType(actions.getTaxListAction.request):
        draft.listEvent = cloneDeep(initEvent)
        draft.listEvent.IsLoading = true
        draft.list.data = []
        draft.list.meta = cloneDeep(initMeta)
        return draft
      case getType(actions.getTaxListAction.success):
        response = action.payload
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitSuccess = true
        draft.list.data = response.data
        if (response.meta) {
          draft.list.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getTaxListAction.failure):
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getTaxDetailAction.request):
        draft.detailEvent = cloneDeep(initEvent)
        draft.detailEvent.IsLoading = true
        draft.detail = undefined
        return draft
      case getType(actions.getTaxDetailAction.success):
        response = action.payload
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitSuccess = true
        if (response) {
          draft.detail = response.data
        }
        return draft
      case getType(actions.getTaxDetailAction.failure):
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.createTaxAction.request):
      case getType(actions.createTaxSupplierAction.request):
      case getType(actions.updateTaxAction.request):
      case getType(actions.deleteTaxAction.request):
        draft.actionEvent = cloneDeep(initEvent)
        draft.actionEvent.IsLoading = true
        return draft
      case getType(actions.createTaxAction.success):
      case getType(actions.createTaxSupplierAction.success):
      case getType(actions.updateTaxAction.success):
        response = action.payload
        if (response?.status?.code === 200 && !response?.error_debug) {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = undefined
          draft.actionEvent.SubmitSuccess = true
          draft.actionEvent.MessageSuccess = 'บันทึกข้อมูลสำเร็จ'
        } else {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = response?.message
        }
        return draft
      case getType(actions.deleteTaxAction.success):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = undefined
        draft.actionEvent.SubmitSuccess = true
        draft.actionEvent.MessageSuccess = 'ลบข้อมูลสำเร็จ'
        return draft
      case getType(actions.createTaxAction.failure):
      case getType(actions.createTaxSupplierAction.failure):
      case getType(actions.updateTaxAction.failure):
      case getType(actions.deleteTaxAction.failure):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getMerchantTaxAction.request):
        draft.merchantTax.event = cloneDeep(initEvent)
        draft.merchantTax.event.IsLoading = true
        draft.merchantTax.data = undefined
        return draft
      case getType(actions.getMerchantTaxAction.success):
        response = action.payload
        draft.merchantTax.event.IsLoading = false
        draft.merchantTax.event.SubmitSuccess = true
        if (response) {
          draft.merchantTax.data = response.data
        }
        return draft
      case getType(actions.getMerchantTaxAction.failure):
        draft.merchantTax.event.IsLoading = false
        draft.merchantTax.event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.updateMerchantTaxAction.request):
        draft.merchantTax.updateEvent = cloneDeep(initEvent)
        draft.merchantTax.updateEvent.IsLoading = true
        return draft
      case getType(actions.updateMerchantTaxAction.success):
        draft.merchantTax.updateEvent.IsLoading = false
        draft.merchantTax.updateEvent.SubmitError = undefined
        draft.merchantTax.updateEvent.SubmitSuccess = true
        draft.merchantTax.updateEvent.MessageSuccess = 'บันทึกข้อมูลสำเร็จ'
        return draft
      case getType(actions.updateMerchantTaxAction.failure):
        draft.merchantTax.updateEvent.IsLoading = false
        draft.merchantTax.updateEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getAllCustomerTaxListAction.request):
        draft.allCustomerTax = []
        return draft
      case getType(actions.getAllCustomerTaxListAction.success):
        response = action.payload
        draft.allCustomerTax = response.data
        return draft
      case getType(actions.clearEventAction):
        draft.listEvent = cloneDeep(initEvent)
        draft.detailEvent = cloneDeep(initEvent)
        draft.actionEvent = cloneDeep(initEvent)
        draft.merchantTax.event = cloneDeep(initEvent)
        draft.merchantTax.updateEvent = cloneDeep(initEvent)
        return draft
      default:
        return state
    }
  })
}
